<template>
    <div>
        <div class="top">
            <span>{{ houseName }}</span>
        </div>
        <div>
            <div :class="preCls + 'filter'" style="margin-top: 10px">
                <filter-date-range
                    :startDate.sync="filter.startDate"
                    :endDate.sync="filter.endDate"
                    @on-change="search"
                ></filter-date-range>
            </div>
            <div style="margin-top: 10px">
                <Table
                    ref="mt"
                    :columns="columns"
                    :data="page.list"
                    :loading="loading"
                    :height="mtHeight"
                >
                    <template v-slot:updateTime="{ row }">
                        {{ row.updateTime | ymdL }}
                    </template>
                    <template v-slot:planAmount="{ row }">
                        {{ `${(row.planAmount / 100).toFixed(2)}` | currency }}
                    </template>
                    <template v-slot:realAmount="{ row }">
                        {{ `${(row.realAmount / 100).toFixed(2)}` | currency }}
                    </template>
                    <template v-slot:billStatus="{ row }">
                        <tag-status
                            :text="dict.billStatus.val(row.billStatus)"
                            :color="
                                row.billStatus == 1
                                    ? 'rgb(191,191,191)'
                                    : 'rgb(10,134,248)'
                            "
                            :background="
                                row.billStatus == 1
                                    ? 'rgb(242,242,242)'
                                    : 'rgb(224,245,255)'
                            "
                            circle
                        />
                    </template>
                </Table>
                <!-- 底部分页 -->
                <table-pager
                    transfer
                    :total.sync="page.totalCount"
                    :pageSize.sync="filter.pageSize"
                    :pageNo.sync="filter.page"
                    @change="fetch"
                ></table-pager>
            </div>
        </div>
    </div>
</template>

<script>
import { billRecordList } from '@/api/bill'
import TagStatus from '_vc/tag-status'
import Dict from '_u/dict'
import { currency } from '_u/helper'
import {
    getResAmountText,
    renderBillAmountText,
} from '@/views/common/u-contract'
import FilterDateRange from '_v/components/filter/filter-date-range'

export default {
    inject: {
        $modal: {
            default: null,
        },
    },
    props: {
        houseName: {
            tyep: String,
            default: '',
        },
        rowId: {
            tyep: [String, Number],
            default: '',
        },
    },
    components: { TagStatus, FilterDateRange },
    data() {
        return {
            mtHeight: 350,
            filter: {
                page: 1,
                pageSize: 20,
                billId: this.rowId,
                startDate: '',
                endDate: '',
            },
            loading: false,
            page: {
                totalCount: 0,
                list: [],
            },
            dict: {
                billStatus: Dict.NULL,
            },
        }
    },
    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60,
                },
                {
                    key: 'updateTime',
                    title: '修改时间',
                    align: 'center',
                    minWidth: 150,
                    slot: 'updateTime',
                },
                {
                    key: 'cusName',
                    title: '客户名称',
                    align: 'left',
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    key: 'cusMobile',
                    title: '手机号',
                    align: 'right',
                    minWidth: 120,
                },
                {
                    key: 'billStatus',
                    title: '账单状态',
                    align: 'center',
                    minWidth: 100,
                    slot: 'billStatus',
                },
                {
                    key: 'receivable',
                    title: '应收金额(元)',
                    align: 'right',
                    minWidth: 160,
                    render: (h, params) => {
                        if (params.row.billStatus === '1') {
                            const obj = {
                                amount: params.row.planAmount.split('\r\n'),
                                update: params.row.update,
                            }
                            return renderBillAmountText(h, obj, 'div', 'div')
                        } else {
                            return h('div', h('div', params.row.planAmount))
                        }
                    },
                },
                {
                    key: 'received',
                    title: '已收金额(元)',
                    align: 'right',
                    minWidth: 120,
                    render: (h, params) => {
                        if (params.row.billStatus === '2') {
                            const obj = {
                                amount: params.row.realAmount.split('\r\n'),
                                update: params.row.update,
                            }
                            return renderBillAmountText(h, obj, 'div', 'div')
                        } else {
                            return h('div', h('div', params.row.realAmount))
                        }
                    },
                },
                {
                    key: 'payable',
                    title: '应付金额(元)',
                    align: 'right',
                    minWidth: 160,
                    render: (h, params) => {
                        if (params.row.billStatus === '3') {
                            const obj = {
                                amount: params.row.planAmount.split('\r\n'),
                                update: params.row.update,
                            }
                            return renderBillAmountText(h, obj, 'div', 'div')
                        } else {
                            return h('div', h('div', params.row.planAmount))
                        }
                    },
                },
                {
                    key: 'paid',
                    title: '已付金额(元)',
                    align: 'right',
                    minWidth: 120,
                    render: (h, params) => {
                        if (params.row.billStatus === '4') {
                            const obj = {
                                amount: params.row.realAmount.split('\r\n'),
                                update: params.row.update,
                            }
                            return renderBillAmountText(h, obj, 'div', 'div')
                        } else {
                            return h('div', h('div', params.row.realAmount))
                        }
                    },
                },
                {
                    key: 'receivableDate',
                    title: '应收款日',
                    align: 'center',
                    minWidth: 110,
                },
                {
                    key: 'receivedDate',
                    title: '已收款时间',
                    align: 'center',
                    minWidth: 150,
                },
                {
                    key: 'payableDate',
                    title: '应付款日',
                    align: 'center',
                    minWidth: 110,
                },
                {
                    key: 'paidDate',
                    title: '已付款时间',
                    align: 'center',
                    minWidth: 150,
                },
                {
                    key: 'nickname',
                    title: '操作人',
                    align: 'center',
                    minWidth: 110,
                },
            ]
        },
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                billRecordList(this.filter),
                Dict.get(['bill_status']),
            ])
                .then((args) => {
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    view.data.page.list.forEach((v) => {
                        v.realAmount = currency(v.realAmount / 100)
                        v.planAmount =
                            currency(v.planAmount / 100) + getResAmountText(v)
                        switch (v.billStatus) {
                            case '1':
                                v.receivable = v.planAmount
                                v.receivableDate = v.planDate
                                break
                            case '2':
                                v.receivable = v.planAmount
                                v.receivableDate = v.planDate

                                v.received = v.realAmount
                                v.receivedDate = v.realDate
                                break
                            case '3':
                                v.payable = v.planAmount
                                v.payableDate = v.planDate
                                break
                            case '4':
                                v.payable = v.planAmount
                                v.payableDate = v.planDate

                                v.paid = v.realAmount
                                v.paidDate = v.realDate
                                break
                        }
                    })
                    this.page.list = view.data.page.list
                    this.page.totalCount = parseInt(view.data.page.totalCount)
                })
                .finally(() => (this.loading = false))
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '关闭', name: 'cancel' }]
        this.$modal.updateBtns(btns)
        // 预加载
    },
}
</script>

<style lang="less" scoped>
.top {
    font-size: 20px;
}
.inlineblock {
    display: inline-block;
    margin-left: 20px;
    font-size: 16px;
    color: rgb(75, 191, 249);
}
</style>
